import React, { Component, PropTypes } from 'react';
import './Voltorb.scss';

class Voltorb extends Component {
  render() {
    return (
      <div className="pokemon">
        <div className="voltorb">
          <div className="head">

          </div>
          <div className="body">

          </div>
        </div>
      </div>
    );
  }
}

export default Voltorb;



/** WEBPACK FOOTER **
 ** ./source/100-voltorb/Voltorb.js
 **/